import { action } from "satcheljs";

export interface UPDATE_FOLDER_COUNTSActionMessage {
    unreadCount: number;
    totalCount: number;
    folderId: string;
    isDeltaChange: boolean;
}
const defaultExport: (unreadCount: number, totalCount: number, folderId: string, isDeltaChange: boolean) => UPDATE_FOLDER_COUNTSActionMessage = action("UPDATE_FOLDER_COUNTS", (unreadCount: number, totalCount: number, folderId: string, isDeltaChange: boolean): UPDATE_FOLDER_COUNTSActionMessage => {
    return {
        unreadCount,
        totalCount,
        folderId,
        isDeltaChange,
    };
});
export default defaultExport;
